import { Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { hasRole, hasPermission } from '../utils/auth.js';

/**
 * Protected route component
 * Redirects to login if user is not authenticated
 * Also handles role-based and permission-based access control
 */
const ProtectedRoute = ({ component: Component, roles, permissions }) => {
    const { isAuthenticated, user } = useSelector((state) => state.auth);

    // If user is not authenticated, redirect to login page (which is at the root path)
    if (!isAuthenticated) {
        return <Navigate to="/" replace />;
    }

    // Check role-based access if roles are specified
    if (roles && !hasRole(user, roles)) {
        // Redirect to dashboard if user doesn't have the required role
        return <Navigate to="/" replace />;
    }

    // Check permission-based access if permissions are specified
    if (permissions && !hasPermission(user, permissions)) {
        // Redirect to dashboard if user doesn't have the required permissions
        return <Navigate to="/" replace />;
    }

    // If all checks pass, render the component
    return <Component />;
};

export default ProtectedRoute;
